// Model.js
// -----------------------
// @module Case
define("Ames.StoreLocator2.StoreLocator2.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

        
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "services/StoreLocator2.Service.ss"
            )
        )
        
});
});
